import { Component, Vue, PropSync } from 'vue-property-decorator';
import { TableDataSetField } from '@/models/tableDataset/TableDataSetField';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';
import { ApiIdentifers } from '@/config';
import { UnitsHelper } from '@/utils';
import { UserProfile } from '@/models/dexie/UserProfile';
import { Configuration } from '@/models/configuration/Configuration';
import { UserProfileStore } from '@/store/store.userProfile';
import { ConfigurationService } from '@/services';
import { Helpers } from '@/helpers/Helpers';
import countries from '@/assets/countries.json';


@Component
export default class SettingsReportFieldComponent extends Vue {
    @PropSync('data', { type: Object }) public syncedData!: TableDataSetField;
    @PropSync('dataAll', { type: Array }) public syncedDataAll!: TableDataSetField[];
    @PropSync('empty', { type: Boolean }) public syncedEmpty!: boolean;


    public userProfile?: UserProfile;
    public unitsConfiguration: Configuration = new Configuration();

    // tslint:disable-next-line: no-empty
    public mounted() {
        this.userProfile = this.getUserProfile;
        this.unitsConfiguration = this.getUnitsConfiguration;
    }

    get getUserProfile(): UserProfile {
        return UserProfileStore.userProfile;
    }

    get getUnitsConfiguration() {
        return ConfigurationService.unitsConfiguration;
    }

    public isUnitField(): boolean {
        return this.syncedData.type === FieldTypeEnum.UNIT;
    }

    public getFieldValue(): string {
        if (this.syncedEmpty === true) {
            return '';
        }
        let value = '-';
        const inField = this.syncedData;
        const inFieldsWithUnit = this.syncedDataAll;
        if (inField.valueBool !== undefined) {
            value = inField.valueBool ? 'yes' : 'no';
        } else if (inField.valueNumber != null) {
            if (inField.type === FieldTypeEnum.NUMBER) {
                if (inField.unit !== undefined && inField.unit !== ApiIdentifers.unitTemperature) {
                    const unitField = inFieldsWithUnit.find((x) => x.identifier === inField.unit);
                    if (unitField !== undefined && unitField.unitIdentifier !== undefined) {
                        value = UnitsHelper.calcByUnit(
                            unitField.unitIdentifier,
                            inField.rangeStep,
                            inField.valueNumber,
                            unitField.valueNumber || undefined);
                    }
                } else if (inField.unit !== undefined && inField.unit === ApiIdentifers.unitTemperature) {
                    // handle temperature extra, format is selected by user profile
                    value = UnitsHelper.calcByUnit(
                        inField.unit,
                        inField.rangeStep,
                        inField.valueNumber,
                        0);

                } else {
                    value = inField.rangeStep
                        ? inField.valueNumber.toFixed(UnitsHelper.getPrecision(inField.rangeStep))
                        : inField.valueNumber.toString();
                }
            } else if (inField.type === FieldTypeEnum.SELECT) {
                if (inField.values !== undefined && inField.values.length > 0) {
                    const fieldValue = inField.values.find((x) => x.value === inField.valueNumber);
                    value = fieldValue && fieldValue.text || inField.valueNumber.toString();
                }
            } else if (inField.type === FieldTypeEnum.AXSELECT) {
                if (inField.axValues !== undefined && inField.axValues.length > 0) {
                    const fieldValue = inField.axValues.find((x) => x.value === inField.valueString);
                    value = fieldValue && fieldValue.text || ( inField.valueString || '');
                }
            } else if (inField.type === FieldTypeEnum.UNIT) {
                const unit = ConfigurationService.GetUnitsConfiguration.sections.find((sec) => sec.identifier === inField.unitIdentifier);
                if (unit !== undefined && unit.values) {
                    value = unit.values[inField.valueNumber].text;
                }
            } else {
                value = inField.valueNumber.toString();
            }
        } else if (inField.valueString !== undefined) {

            if (inField.identifier === ApiIdentifers.generalTrialDate) {
                value = `${Helpers.getFormattedDateString(inField.valueString)} ${Helpers.getFormattedTimeString(inField.valueString)}`;
            } else if (inField.identifier === ApiIdentifers.axCountry) {
                const country = countries.find((c: any) => c.id === inField.valueString);
                if (country) {
                    value = country.name;
                }
            } else {
                value = inField.valueString;
            }
        }

        return value;
    }

    public getUnitFormat(): string {
        const inField = this.syncedData;
        let unitFormatName: string = '';

        if (inField.type === FieldTypeEnum.NUMBER && inField.unit !== undefined) {
            let unitFormatId: string = ApiIdentifers.unitTemperature; // handle temperature extra, format is selected by user profile
            if (inField.unit !== ApiIdentifers.unitTemperature) {
                const unit = this.syncedDataAll.find((x) => x.identifier === inField.unit);
                if (unit !== undefined && unit.unitIdentifier !== undefined) {
                    unitFormatId = unit.unitIdentifier;
                } else {
                    unitFormatId = '';
                }
            }
            if (unitFormatId.length > 0) {
                const unitFormat = this.unitsConfiguration.sections.find((sec) => sec.identifier === unitFormatId);
                if (unitFormat !== undefined && unitFormat.values !== undefined && this.userProfile !== undefined) {
                    const userProfileFormat = this.userProfile.units.find((upf) => upf.unitIdentifier === unitFormatId);
                    unitFormatName = userProfileFormat !== undefined && userProfileFormat.selectedValue !== undefined
                        ? (unitFormat.values.find((v) => v.value === userProfileFormat.selectedValue) || { text: '-' }).text
                        : (unitFormat.values.find((v) => v.value === unitFormat.base) || unitFormat.values[0]).text;
                }
            }
        } else if (inField.fixedUnit !== undefined) {
            unitFormatName = inField.fixedUnit;
        }

        return unitFormatName;
    }
}
